import { Glyphicon } from 'react-bootstrap';
import Button from 'components/button/Button';
import PencilSquareIcon from 'assets/images/icons/pencil-square.svg?react';
import DuplicateIcon from 'assets/images/icons/duplicate.svg?react';
import Tooltip from 'components/tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { Row } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';
import { CustomTemplate } from 'models/automation/CustomTemplates';
import { ActionsCellStyled } from '../CustomTemplatesTable.styles';
import useDeleteCustomTemplateModal from '../../modal/delete/useDeleteCustomTemplateModal';
import useDuplicateCustomTemplate from '../actions/useDuplicateCustomTemplate';

const ActionsCell = ({ row }: { row: Row<CustomTemplate> }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openDeleteCustomTemplateModal } = useDeleteCustomTemplateModal();
  const { duplicateCustomTemplate } = useDuplicateCustomTemplate();

  const handleEditModal = () => {
    navigate(`./${row.original.uid}`);
  };

  const handleDeleteModal = () => {
    openDeleteCustomTemplateModal(row.original);
  };

  const handleDuplicateModal = () => {
    duplicateCustomTemplate({ customTemplateUid: row.original.uid });
  };

  return (
    <ActionsCellStyled>
      <Tooltip id="row-edit-custom-template-button" text={t('common.edit')}>
        <Button
          bsStyle="link"
          data-testid="row-edit-custom-template-button"
          onClick={handleEditModal}
        >
          <PencilSquareIcon aria-label={t('common.edit')} />
        </Button>
      </Tooltip>

      <Tooltip
        id="row-duplicate-custom-template-button"
        text={t('common.duplicate')}
      >
        <Button
          bsStyle="link"
          data-testid="row-duplicate-custom-template-button"
          onClick={handleDuplicateModal}
        >
          <DuplicateIcon aria-label={t('common.duplicate')} />
        </Button>
      </Tooltip>

      <Tooltip id="row-delete-custom-template-button" text={t('common.delete')}>
        <Button
          bsStyle="link"
          data-testid="row-delete-custom-template-button"
          onClick={handleDeleteModal}
        >
          <Glyphicon glyph="trash" aria-label={t('common.delete')} />
        </Button>
      </Tooltip>
    </ActionsCellStyled>
  );
};

export default ActionsCell;
